import 'core-js/es/symbol/for';
import 'core-js/es/symbol/iterator';
import 'core-js/es/promise';
import 'whatwg-fetch';
import 'document-register-element/build/document-register-element';
import 'reflect-metadata';
import 'intl';
import 'intl/locale-data/jsonp/de-DE';

import './class-component-hooks';

import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import VueIntl from 'vue-intl';
import Vuex from 'vuex';

import App from './App.vue';
import HighlightMarker from './components/highlight-marker.vue';
import { getConfig } from './lib/ConfigLoader';
import { setDeviceSize } from './lib/core/responsive';
import router from './router';
import store from './store';

// custom-element polyfill for firefox

// dependency injection needs this

// internationalization

export default function main(): void {
	const config = getConfig();

	setDeviceSize(config.responsive);

	// Vue.use(ScrollView);
	Vue.use(VueIntl);
	Vue.use(VueCustomElement);
	Vue.use(Vuex);

	Vue.setLocale(config.defaultIsoLocale);

	Vue.customElement('highlight-marker', {
		template:
			'<highlight-marker' +
			' :active="active"' +
			' :slider-enabled="sliderEnabled"' +
			' :active-icon="activeIcon"' +
			' :inactive-icon="inactiveIcon"' +
			' :slider-width="sliderWidth"' +
			' :src="src"' +
			' :headline="headline"' +
			' :content="content"' +
			' :content-offset-top="contentOffsetTop"' +
			' :content-offset-bottom="contentOffsetBottom"' +
			' :ekomi-id="ekomiId"></highlight-marker>',
		props: [
			'active',
			'sliderEnabled',
			'activeIcon',
			'inactiveIcon',
			'sliderWidth',
			'src',
			'headline',
			'content',
			'contentOffsetTop',
			'contentOffsetBottom',
			'ekomiId'
		],
		components: { HighlightMarker }
	});

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app');
}
